import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuick from "@/pages/home/components/CategoryQuick";
import LatestAnime from "@/pages/home/components/LatestAnime";
import NewsPreview from "@/pages/home/components/NewsPreview";
import TopicSection from "@/pages/home/components/TopicSection";

export default function Home() {
  return (
    <div className="w-full">
      <h1 className="sr-only">51动漫 - 海量动漫资源与最新资讯平台</h1>
      <HeroCarousel />
      <CategoryQuick />
      <LatestAnime />
      <NewsPreview />
      <TopicSection />
    </div>
  );
}